import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSJSON: { input: { [x: string]: any }; output: { [x: string]: any }; }
  AWSPhone: { input: string; output: string; }
  AWSURL: { input: string; output: string; }
};

export type ActiveCardioExercise = {
  __typename?: 'ActiveCardioExercise';
  angle?: Maybe<ActiveParameter>;
  id: Scalars['ID']['output'];
  intervals?: Maybe<Array<Maybe<ActiveCardioExerciseInterval>>>;
  machine_number?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  resistance?: Maybe<ActiveParameter>;
  seat_height?: Maybe<Scalars['String']['output']>;
  type: ExerciseType;
  video_url: Scalars['String']['output'];
  xid: Scalars['ID']['output'];
};

export type ActiveCardioExerciseInterval = {
  __typename?: 'ActiveCardioExerciseInterval';
  angle?: Maybe<ActiveParameter>;
  distance?: Maybe<ActiveParameter>;
  duration?: Maybe<ActiveParameter>;
  end_at?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  intensity?: Maybe<ActiveParameter>;
  resistance?: Maybe<ActiveParameter>;
  rest?: Maybe<ActiveParameter>;
  target_heart_rate?: Maybe<ActiveParameter>;
  tempo?: Maybe<ActiveParameter>;
};

export type ActiveExercise = ActiveCardioExercise | ActiveStrengthExercise;

export type ActiveParameter = {
  __typename?: 'ActiveParameter';
  done?: Maybe<Scalars['Float']['output']>;
  end_at?: Maybe<Scalars['AWSDateTime']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  val?: Maybe<Scalars['Float']['output']>;
};

export type ActiveStrengthExercise = {
  __typename?: 'ActiveStrengthExercise';
  angle?: Maybe<ActiveParameter>;
  id: Scalars['ID']['output'];
  machine_number?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  resistance?: Maybe<ActiveParameter>;
  seat_height?: Maybe<Scalars['String']['output']>;
  sets?: Maybe<Array<Maybe<ActiveStrengthExerciseSet>>>;
  type: ExerciseType;
  video_url: Scalars['String']['output'];
  xid: Scalars['ID']['output'];
};

export type ActiveStrengthExerciseDropSet = {
  __typename?: 'ActiveStrengthExerciseDropSet';
  end_at?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  reps?: Maybe<ActiveParameter>;
  weight?: Maybe<ActiveParameter>;
};

export type ActiveStrengthExerciseSet = {
  __typename?: 'ActiveStrengthExerciseSet';
  dropsets?: Maybe<Array<ActiveStrengthExerciseDropSet>>;
  end_at?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  reps?: Maybe<ActiveParameter>;
  rest?: Maybe<ActiveParameter>;
  weight?: Maybe<ActiveParameter>;
};

export type ActiveWorkout = Document & {
  __typename?: 'ActiveWorkout';
  clubId: Scalars['ID']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  end_at?: Maybe<Scalars['AWSDateTime']['output']>;
  exercises?: Maybe<Array<ActiveExercise>>;
  id: Scalars['ID']['output'];
  memberId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['ID']['output']>;
  started_at: Scalars['AWSDateTime']['output'];
  tenantId: Scalars['ID']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
  workoutId: Scalars['ID']['output'];
};

export type ActiveWorkoutConnection = {
  __typename?: 'ActiveWorkoutConnection';
  items?: Maybe<Array<ActiveWorkout>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type AddExerciseToWorkoutInput = {
  machine_number?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  seat_height?: InputMaybe<Scalars['String']['input']>;
  type: ExerciseType;
  xid: Scalars['ID']['input'];
};

export type CardioExercise = {
  __typename?: 'CardioExercise';
  angle?: Maybe<Parameter>;
  id: Scalars['ID']['output'];
  intervals?: Maybe<Array<Maybe<CardioExerciseInterval>>>;
  machine_number?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  resistance?: Maybe<Parameter>;
  seat_height?: Maybe<Scalars['String']['output']>;
  target_heart_rate?: Maybe<Parameter>;
  type: ExerciseType;
  xid: Scalars['ID']['output'];
};

export type CardioExerciseInterval = {
  __typename?: 'CardioExerciseInterval';
  angle?: Maybe<Parameter>;
  distance?: Maybe<Parameter>;
  duration?: Maybe<Parameter>;
  id: Scalars['ID']['output'];
  intensity?: Maybe<Parameter>;
  resistance?: Maybe<Parameter>;
  rest?: Maybe<Parameter>;
  target_heart_rate?: Maybe<Parameter>;
  tempo?: Maybe<Parameter>;
};

export type Club = Document & {
  __typename?: 'Club';
  address: Scalars['String']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  email: Scalars['AWSEmail']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone_number: Scalars['AWSPhone']['output'];
  profile_picture: Scalars['AWSURL']['output'];
  tenantId: Scalars['ID']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
};

export type ClubConnection = {
  __typename?: 'ClubConnection';
  items?: Maybe<Array<Club>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type CreateEventInput = {
  planId: Scalars['ID']['input'];
  start_at: Scalars['AWSDateTime']['input'];
};

export type CreateMeasurementInput = {
  fat?: InputMaybe<Scalars['Float']['input']>;
  heart_rate?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  memberId?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateMemberInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthdate: Scalars['AWSDate']['input'];
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  gender: Gender;
  measurement?: InputMaybe<CreateMemberMeasurementInput>;
  name: Scalars['String']['input'];
  phone_number: Scalars['AWSPhone']['input'];
};

export type CreateMemberMeasurementInput = {
  fat?: InputMaybe<Scalars['Float']['input']>;
  heart_rate?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePlanInput = {
  meetings: Scalars['Int']['input'];
  memberId: Scalars['ID']['input'];
  weeks: Scalars['Int']['input'];
};

export type CreateTrainerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthdate: Scalars['AWSDate']['input'];
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  gender: Gender;
  name: Scalars['String']['input'];
  phone_number: Scalars['AWSPhone']['input'];
};

export type CreateWorkoutInput = {
  library?: InputMaybe<Scalars['Boolean']['input']>;
  memberId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  planId?: InputMaybe<Scalars['ID']['input']>;
};

export type Document = {
  created_at: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
};

export type EndDropsetInput = {
  dropsetId: Scalars['ID']['input'];
  exerciseId: Scalars['ID']['input'];
  reps?: InputMaybe<Scalars['Int']['input']>;
  setId: Scalars['ID']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type EndIntervalInput = {
  angle?: InputMaybe<Scalars['Float']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  exerciseId: Scalars['ID']['input'];
  intensity?: InputMaybe<Scalars['Float']['input']>;
  intervalId: Scalars['ID']['input'];
  resistance?: InputMaybe<Scalars['Float']['input']>;
  rest?: InputMaybe<Scalars['Float']['input']>;
  target_heart_rate?: InputMaybe<Scalars['Float']['input']>;
  tempo?: InputMaybe<Scalars['Float']['input']>;
};

export type EndSetInput = {
  exerciseId: Scalars['ID']['input'];
  reps?: InputMaybe<Scalars['Int']['input']>;
  rest?: InputMaybe<Scalars['Float']['input']>;
  setId: Scalars['ID']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type Event = {
  __typename?: 'Event';
  clubId: Scalars['ID']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  memberId: Scalars['ID']['output'];
  start_at: Scalars['AWSDateTime']['output'];
  tenantId: Scalars['ID']['output'];
  trainerId: Scalars['ID']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
};

export type EventConnection = {
  __typename?: 'EventConnection';
  items?: Maybe<Array<Event>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Exercise = CardioExercise | StrengthExercise;

export type ExerciseList = {
  __typename?: 'ExerciseList';
  items?: Maybe<Array<ExerciseListItem>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ExerciseListItem = {
  __typename?: 'ExerciseListItem';
  equipment: Scalars['String']['output'];
  equipment_hebrew: Scalars['String']['output'];
  exercise: Scalars['String']['output'];
  hebrew: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  search: Scalars['String']['output'];
};

export enum ExerciseType {
  Cardio = 'CARDIO',
  Strength = 'STRENGTH'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type Goal = Document & {
  __typename?: 'Goal';
  clubId?: Maybe<Scalars['ID']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  completed_at?: Maybe<Scalars['AWSDateTime']['output']>;
  created_at: Scalars['AWSDateTime']['output'];
  fat?: Maybe<Scalars['Float']['output']>;
  heart_rate?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  memberId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type GoalConnection = {
  __typename?: 'GoalConnection';
  items?: Maybe<Array<Goal>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ImportWorkoutFromLibraryInput = {
  memberId?: InputMaybe<Scalars['ID']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
};

export type IntervalInput = {
  angle?: InputMaybe<ParameterInput>;
  distance?: InputMaybe<ParameterInput>;
  duration?: InputMaybe<ParameterInput>;
  intensity?: InputMaybe<ParameterInput>;
  resistance?: InputMaybe<ParameterInput>;
  rest?: InputMaybe<ParameterInput>;
  target_heart_rate?: InputMaybe<ParameterInput>;
  tempo?: InputMaybe<ParameterInput>;
};

export type Measurement = Document & {
  __typename?: 'Measurement';
  clubId?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['AWSDateTime']['output'];
  fat?: Maybe<Scalars['Float']['output']>;
  heart_rate?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  memberId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type MeasurementConnection = {
  __typename?: 'MeasurementConnection';
  items?: Maybe<Array<Measurement>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Member = Document & {
  __typename?: 'Member';
  address?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['AWSDate']['output']>;
  created_at: Scalars['AWSDateTime']['output'];
  email?: Maybe<Scalars['AWSEmail']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Goal>;
  id: Scalars['ID']['output'];
  measurement?: Maybe<Measurement>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['AWSPhone']['output']>;
  picture?: Maybe<Scalars['AWSURL']['output']>;
  plans?: Maybe<PlanConnection>;
  profile_picture?: Maybe<Scalars['AWSURL']['output']>;
  profile_workouts?: Maybe<WorkoutConnection>;
  registered?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['AWSJSON']['output']>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
};

export type MemberConnection = {
  __typename?: 'MemberConnection';
  items?: Maybe<Array<Member>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addExerciseToWorkout?: Maybe<Workout>;
  addIntervalToExercise?: Maybe<Workout>;
  addSetToExercise?: Maybe<Workout>;
  addWorkoutToLibrary?: Maybe<Workout>;
  createEvent?: Maybe<Event>;
  createMeasurement?: Maybe<Measurement>;
  createMeasurementForMember?: Maybe<Measurement>;
  createMember?: Maybe<Member>;
  createPlan?: Maybe<Plan>;
  createTrainer?: Maybe<Trainer>;
  createWorkout?: Maybe<Workout>;
  deleteEvent?: Maybe<Event>;
  deleteExerciseFromWorkout?: Maybe<Workout>;
  deleteIntervalFromExercise?: Maybe<Workout>;
  deletePlan?: Maybe<Plan>;
  deleteSetFromExercise?: Maybe<Workout>;
  deleteWorkout?: Maybe<Workout>;
  endActiveWorkout?: Maybe<ActiveWorkout>;
  endActiveWorkoutDropset?: Maybe<ActiveWorkout>;
  endActiveWorkoutInterval?: Maybe<ActiveWorkout>;
  endActiveWorkoutSet?: Maybe<ActiveWorkout>;
  importWorkoutFromLibrary?: Maybe<Workout>;
  moveExerciseInWorkout?: Maybe<Workout>;
  moveIntervalInExercise?: Maybe<Workout>;
  moveSetInExercise?: Maybe<Workout>;
  register?: Maybe<Member>;
  startActiveWorkout?: Maybe<ActiveWorkout>;
  test?: Maybe<Measurement>;
  updateExerciseInWorkout?: Maybe<Workout>;
  updateIntervalInExercise?: Maybe<Workout>;
  updateMemberProfile?: Maybe<Member>;
  updateSetInExercise?: Maybe<Workout>;
  updateWorkout?: Maybe<Workout>;
};


export type MutationAddExerciseToWorkoutArgs = {
  input: AddExerciseToWorkoutInput;
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationAddIntervalToExerciseArgs = {
  exerciseId: Scalars['ID']['input'];
  input: IntervalInput;
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationAddSetToExerciseArgs = {
  exerciseId: Scalars['ID']['input'];
  input: SetInput;
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationAddWorkoutToLibraryArgs = {
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateMeasurementArgs = {
  input: CreateMeasurementInput;
};


export type MutationCreateMeasurementForMemberArgs = {
  input: CreateMeasurementInput;
  memberId: Scalars['ID']['input'];
};


export type MutationCreateMemberArgs = {
  input: CreateMemberInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
  trainerId: Scalars['ID']['input'];
};


export type MutationCreateTrainerArgs = {
  input: CreateTrainerInput;
};


export type MutationCreateWorkoutArgs = {
  input: CreateWorkoutInput;
  trainerId: Scalars['ID']['input'];
};


export type MutationDeleteEventArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationDeleteExerciseFromWorkoutArgs = {
  exerciseId: Scalars['ID']['input'];
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationDeleteIntervalFromExerciseArgs = {
  exerciseId: Scalars['ID']['input'];
  intervalId: Scalars['ID']['input'];
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationDeletePlanArgs = {
  planId: Scalars['ID']['input'];
};


export type MutationDeleteSetFromExerciseArgs = {
  exerciseId: Scalars['ID']['input'];
  setId: Scalars['ID']['input'];
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationDeleteWorkoutArgs = {
  workoutId: Scalars['ID']['input'];
};


export type MutationEndActiveWorkoutDropsetArgs = {
  input: EndDropsetInput;
};


export type MutationEndActiveWorkoutIntervalArgs = {
  input: EndIntervalInput;
};


export type MutationEndActiveWorkoutSetArgs = {
  input: EndSetInput;
};


export type MutationImportWorkoutFromLibraryArgs = {
  input: ImportWorkoutFromLibraryInput;
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationMoveExerciseInWorkoutArgs = {
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationMoveIntervalInExerciseArgs = {
  exerciseId: Scalars['ID']['input'];
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationMoveSetInExerciseArgs = {
  exerciseId: Scalars['ID']['input'];
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationStartActiveWorkoutArgs = {
  workoutId: Scalars['ID']['input'];
};


export type MutationTestArgs = {
  input: CreateMeasurementInput;
};


export type MutationUpdateExerciseInWorkoutArgs = {
  exerciseId: Scalars['ID']['input'];
  input: UpdateExerciseInWorkoutInput;
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationUpdateIntervalInExerciseArgs = {
  exerciseId: Scalars['ID']['input'];
  input: IntervalInput;
  intervalId: Scalars['ID']['input'];
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationUpdateMemberProfileArgs = {
  input: UpdateMemberProfileInput;
};


export type MutationUpdateSetInExerciseArgs = {
  exerciseId: Scalars['ID']['input'];
  input: SetInput;
  setId: Scalars['ID']['input'];
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationUpdateWorkoutArgs = {
  input: UpdateWorkoutInput;
  trainerId: Scalars['ID']['input'];
  workoutId: Scalars['ID']['input'];
};

export type Parameter = {
  __typename?: 'Parameter';
  max?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  val?: Maybe<Scalars['Float']['output']>;
};

export type ParameterInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  val?: InputMaybe<Scalars['Float']['input']>;
};

export type Plan = Document & {
  __typename?: 'Plan';
  activeWorkouts?: Maybe<ActiveWorkoutConnection>;
  clubId: Scalars['ID']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  events?: Maybe<EventConnection>;
  id: Scalars['ID']['output'];
  meetings: Scalars['Int']['output'];
  member?: Maybe<Member>;
  memberId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
  trainer?: Maybe<Trainer>;
  trainerId: Scalars['ID']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
  weeks: Scalars['Int']['output'];
  workouts?: Maybe<WorkoutConnection>;
};

export type PlanConnection = {
  __typename?: 'PlanConnection';
  items?: Maybe<Array<Plan>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  getActiveWorkout?: Maybe<ActiveWorkout>;
  getClubById?: Maybe<Club>;
  getClubTrainers?: Maybe<Array<Trainer>>;
  getCurrentMember?: Maybe<Member>;
  getMemberById?: Maybe<Member>;
  getPlanById?: Maybe<Plan>;
  getTenant?: Maybe<Tenant>;
  getTrainerById?: Maybe<Trainer>;
  getWorkoutById?: Maybe<Workout>;
  listActiveWorkoutsHistory?: Maybe<ActiveWorkoutConnection>;
  listLibraryWorkouts?: Maybe<WorkoutConnection>;
  listPlansByClub?: Maybe<PlanConnection>;
  listPlansByMemberId?: Maybe<PlanConnection>;
  listPlansByTrainerId?: Maybe<PlanConnection>;
  searchExercises?: Maybe<ExerciseList>;
  searchMembers?: Maybe<Array<Maybe<Member>>>;
};


export type QueryGetClubByIdArgs = {
  clubId: Scalars['ID']['input'];
};


export type QueryGetMemberByIdArgs = {
  memberId: Scalars['ID']['input'];
};


export type QueryGetPlanByIdArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryGetTrainerByIdArgs = {
  trainerId: Scalars['ID']['input'];
};


export type QueryGetWorkoutByIdArgs = {
  workoutId: Scalars['ID']['input'];
};


export type QueryListLibraryWorkoutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListPlansByClubArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListPlansByMemberIdArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['ID']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListPlansByTrainerIdArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  trainerId: Scalars['ID']['input'];
};


export type QuerySearchExercisesArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchMembersArgs = {
  text: Scalars['String']['input'];
};

export type RegisterInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthdate: Scalars['AWSDate']['input'];
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  gender: Gender;
  name: Scalars['String']['input'];
  profile_picture?: InputMaybe<Scalars['AWSURL']['input']>;
};

export type SetInput = {
  dropsets?: InputMaybe<Array<StrengthExerciseDropSetInput>>;
  reps?: InputMaybe<ParameterInput>;
  rest?: InputMaybe<ParameterInput>;
  times?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<ParameterInput>;
};

export type StrengthExercise = {
  __typename?: 'StrengthExercise';
  angle?: Maybe<Parameter>;
  id: Scalars['ID']['output'];
  machine_number?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  resistance?: Maybe<Parameter>;
  seat_height?: Maybe<Scalars['String']['output']>;
  sets?: Maybe<Array<Maybe<StrengthExerciseSet>>>;
  type: ExerciseType;
  xid: Scalars['ID']['output'];
};

export type StrengthExerciseDropSet = {
  __typename?: 'StrengthExerciseDropSet';
  id: Scalars['ID']['output'];
  reps?: Maybe<Parameter>;
  weight?: Maybe<Parameter>;
};

export type StrengthExerciseDropSetInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  reps?: InputMaybe<ParameterInput>;
  weight?: InputMaybe<ParameterInput>;
};

export type StrengthExerciseSet = {
  __typename?: 'StrengthExerciseSet';
  dropsets?: Maybe<Array<StrengthExerciseDropSet>>;
  id: Scalars['ID']['output'];
  reps?: Maybe<Parameter>;
  rest?: Maybe<Parameter>;
  weight?: Maybe<Parameter>;
};

export type Tenant = {
  __typename?: 'Tenant';
  address: Scalars['String']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  email: Scalars['AWSEmail']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone_number: Scalars['AWSPhone']['output'];
  profile_picture: Scalars['AWSURL']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
};

export type Trainer = Document & {
  __typename?: 'Trainer';
  address?: Maybe<Scalars['String']['output']>;
  birthdate: Scalars['AWSDate']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  email?: Maybe<Scalars['AWSEmail']['output']>;
  gender: Gender;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone_number: Scalars['AWSPhone']['output'];
  picture?: Maybe<Scalars['AWSURL']['output']>;
  tenantId: Scalars['ID']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
};

export type TrainerConnection = {
  __typename?: 'TrainerConnection';
  items?: Maybe<Array<Trainer>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type UpdateExerciseInWorkoutInput = {
  machine_number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  seat_height?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ExerciseType>;
  xid?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateMemberProfileInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['AWSDate']['input']>;
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  gender?: InputMaybe<Gender>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['AWSURL']['input']>;
  profile_picture?: InputMaybe<Scalars['AWSURL']['input']>;
};

export type UpdateWorkoutInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type Workout = Document & {
  __typename?: 'Workout';
  clubId: Scalars['ID']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  exercises?: Maybe<Array<Exercise>>;
  id: Scalars['ID']['output'];
  library?: Maybe<Scalars['Boolean']['output']>;
  memberId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
  trainer?: Maybe<Trainer>;
  trainerId: Scalars['ID']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
};

export type WorkoutConnection = {
  __typename?: 'WorkoutConnection';
  items?: Maybe<Array<Workout>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type EndActiveWorkoutMutationVariables = Exact<{ [key: string]: never; }>;


export type EndActiveWorkoutMutation = { __typename?: 'Mutation', endActiveWorkout?: { __typename?: 'ActiveWorkout', id: string } | null };

export type EndActiveWorkoutDropsetMutationVariables = Exact<{
  input: EndDropsetInput;
}>;


export type EndActiveWorkoutDropsetMutation = { __typename?: 'Mutation', endActiveWorkoutDropset?: { __typename?: 'ActiveWorkout', id: string } | null };

export type EndActiveWorkoutIntervalMutationVariables = Exact<{
  input: EndIntervalInput;
}>;


export type EndActiveWorkoutIntervalMutation = { __typename?: 'Mutation', endActiveWorkoutInterval?: { __typename?: 'ActiveWorkout', id: string } | null };

export type EndActiveWorkoutSetMutationVariables = Exact<{
  input: EndSetInput;
}>;


export type EndActiveWorkoutSetMutation = { __typename?: 'Mutation', endActiveWorkoutSet?: { __typename?: 'ActiveWorkout', id: string } | null };

export type GetActiveWorkoutQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveWorkoutQuery = { __typename?: 'Query', getActiveWorkout?: { __typename?: 'ActiveWorkout', id: string, tenantId: string, clubId: string, workoutId: string, created_at: string, updated_at: string, started_at: string, name: string, memberId: string, planId?: string | null, end_at?: string | null, exercises?: Array<{ __typename?: 'ActiveCardioExercise', type: ExerciseType, id: string, xid: string, name: string, notes?: string | null, machine_number?: string | null, video_url: string, seat_height?: string | null, intervals?: Array<{ __typename?: 'ActiveCardioExerciseInterval', end_at?: string | null, id: string, duration?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, distance?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, tempo?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, intensity?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, angle?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, resistance?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, rest?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, target_heart_rate?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null } | null> | null } | { __typename?: 'ActiveStrengthExercise', type: ExerciseType, id: string, xid: string, name: string, notes?: string | null, machine_number?: string | null, seat_height?: string | null, video_url: string, sets?: Array<{ __typename?: 'ActiveStrengthExerciseSet', end_at?: string | null, id: string, reps?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, weight?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, rest?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, dropsets?: Array<{ __typename?: 'ActiveStrengthExerciseDropSet', end_at?: string | null, id: string, reps?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, weight?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null }> | null } | null> | null }> | null } | null };

export type StartActiveWorkoutMutationVariables = Exact<{
  workoutId: Scalars['ID']['input'];
}>;


export type StartActiveWorkoutMutation = { __typename?: 'Mutation', startActiveWorkout?: { __typename?: 'ActiveWorkout', id: string, tenantId: string, clubId: string, workoutId: string, created_at: string, updated_at: string, started_at: string, name: string, memberId: string, planId?: string | null, end_at?: string | null, exercises?: Array<{ __typename?: 'ActiveCardioExercise', type: ExerciseType, id: string, xid: string, name: string, notes?: string | null, machine_number?: string | null, video_url: string, seat_height?: string | null, intervals?: Array<{ __typename?: 'ActiveCardioExerciseInterval', end_at?: string | null, id: string, duration?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, distance?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, tempo?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, intensity?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, angle?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, resistance?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, rest?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, target_heart_rate?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null } | null> | null } | { __typename?: 'ActiveStrengthExercise', type: ExerciseType, id: string, xid: string, name: string, notes?: string | null, machine_number?: string | null, seat_height?: string | null, video_url: string, sets?: Array<{ __typename?: 'ActiveStrengthExerciseSet', end_at?: string | null, id: string, reps?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, weight?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, rest?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, dropsets?: Array<{ __typename?: 'ActiveStrengthExerciseDropSet', end_at?: string | null, id: string, reps?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, weight?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null }> | null } | null> | null }> | null } | null };

export type ActiveStrengthExerciseFragmentFragment = { __typename?: 'ActiveStrengthExercise', type: ExerciseType, id: string, xid: string, name: string, notes?: string | null, machine_number?: string | null, seat_height?: string | null, video_url: string, sets?: Array<{ __typename?: 'ActiveStrengthExerciseSet', end_at?: string | null, id: string, reps?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, weight?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, rest?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, dropsets?: Array<{ __typename?: 'ActiveStrengthExerciseDropSet', end_at?: string | null, id: string, reps?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, weight?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null }> | null } | null> | null };

export type ActiveCardioExerciseFragmentFragment = { __typename?: 'ActiveCardioExercise', type: ExerciseType, id: string, xid: string, name: string, notes?: string | null, machine_number?: string | null, video_url: string, seat_height?: string | null, intervals?: Array<{ __typename?: 'ActiveCardioExerciseInterval', end_at?: string | null, id: string, duration?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, distance?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, tempo?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, intensity?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, angle?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, resistance?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, rest?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null, target_heart_rate?: { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null } | null } | null> | null };

export type ActiveParameterFragmentFragment = { __typename?: 'ActiveParameter', max?: number | null, val?: number | null, unit?: string | null, done?: number | null, end_at?: string | null };

export type StrengthExerciseFragmentFragment = { __typename?: 'StrengthExercise', type: ExerciseType, id: string, xid: string, name: string, notes?: string | null, machine_number?: string | null, seat_height?: string | null, sets?: Array<{ __typename?: 'StrengthExerciseSet', id: string, reps?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, weight?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, rest?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, dropsets?: Array<{ __typename?: 'StrengthExerciseDropSet', id: string, reps?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, weight?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null }> | null } | null> | null };

export type CardioExerciseFragmentFragment = { __typename?: 'CardioExercise', type: ExerciseType, id: string, xid: string, name: string, notes?: string | null, machine_number?: string | null, seat_height?: string | null, intervals?: Array<{ __typename?: 'CardioExerciseInterval', id: string, duration?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, distance?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, tempo?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, intensity?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, angle?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, resistance?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, rest?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null } | null> | null };

export type ParameterFragmentFragment = { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null };

export type CreateMeasurementMutationVariables = Exact<{
  input: CreateMeasurementInput;
}>;


export type CreateMeasurementMutation = { __typename?: 'Mutation', createMeasurement?: { __typename?: 'Measurement', id: string, height?: number | null, weight?: number | null, fat?: number | null, heart_rate?: number | null } | null };

export type GetCurrentMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentMemberQuery = { __typename?: 'Query', getCurrentMember?: { __typename?: 'Member', id: string, email?: string | null, name?: string | null, tenantId: string, phone_number?: string | null, created_at: string, updated_at: string, picture?: string | null, gender?: string | null, address?: string | null, birthdate?: string | null, measurement?: { __typename?: 'Measurement', height?: number | null, weight?: number | null, fat?: number | null, heart_rate?: number | null } | null, profile_workouts?: { __typename?: 'WorkoutConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Workout', id: string, name: string, created_at: string, updated_at: string, trainerId: string }> | null } | null, plans?: { __typename?: 'PlanConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Plan', id: string, tenantId: string, weeks: number, meetings: number, created_at: string, updated_at: string, trainerId: string, memberId: string, trainer?: { __typename?: 'Trainer', name: string, id: string, picture?: string | null } | null, events?: { __typename?: 'EventConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Event', id: string, start_at: string }> | null } | null, workouts?: { __typename?: 'WorkoutConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Workout', id: string, name: string, created_at: string, updated_at: string }> | null } | null }> | null } | null } | null };

export type UpdateMemberProfileMutationVariables = Exact<{
  input: UpdateMemberProfileInput;
}>;


export type UpdateMemberProfileMutation = { __typename?: 'Mutation', updateMemberProfile?: { __typename?: 'Member', id: string } | null };

export type GetWorkoutByIdQueryVariables = Exact<{
  workoutId: Scalars['ID']['input'];
}>;


export type GetWorkoutByIdQuery = { __typename?: 'Query', getWorkoutById?: { __typename?: 'Workout', id: string, tenantId: string, clubId: string, created_at: string, updated_at: string, trainerId: string, memberId?: string | null, name: string, notes?: string | null, library?: boolean | null, trainer?: { __typename?: 'Trainer', id: string, name: string, picture?: string | null } | null, exercises?: Array<{ __typename: 'CardioExercise', type: ExerciseType, id: string, xid: string, name: string, notes?: string | null, machine_number?: string | null, seat_height?: string | null, intervals?: Array<{ __typename?: 'CardioExerciseInterval', id: string, duration?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, distance?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, tempo?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, intensity?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, angle?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, resistance?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, rest?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null } | null> | null } | { __typename: 'StrengthExercise', type: ExerciseType, id: string, xid: string, name: string, notes?: string | null, machine_number?: string | null, seat_height?: string | null, sets?: Array<{ __typename?: 'StrengthExerciseSet', id: string, reps?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, weight?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, rest?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, dropsets?: Array<{ __typename?: 'StrengthExerciseDropSet', id: string, reps?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null, weight?: { __typename?: 'Parameter', max?: number | null, val?: number | null, unit?: string | null } | null }> | null } | null> | null }> | null } | null };

export type ListActiveWorkoutsHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type ListActiveWorkoutsHistoryQuery = { __typename?: 'Query', listActiveWorkoutsHistory?: { __typename?: 'ActiveWorkoutConnection', nextToken?: string | null, items?: Array<{ __typename?: 'ActiveWorkout', id: string, end_at?: string | null, started_at: string, name: string }> | null } | null };

export const ActiveParameterFragmentFragmentDoc = gql`
    fragment ActiveParameterFragment on ActiveParameter {
  max
  val
  unit
  done
  end_at
}
    `;
export const ActiveStrengthExerciseFragmentFragmentDoc = gql`
    fragment ActiveStrengthExerciseFragment on ActiveStrengthExercise {
  type
  id
  xid
  name
  notes
  machine_number
  seat_height
  video_url
  sets {
    end_at
    id
    reps {
      ...ActiveParameterFragment
    }
    weight {
      ...ActiveParameterFragment
    }
    rest {
      ...ActiveParameterFragment
    }
    dropsets {
      end_at
      id
      reps {
        ...ActiveParameterFragment
      }
      weight {
        ...ActiveParameterFragment
      }
    }
  }
}
    ${ActiveParameterFragmentFragmentDoc}`;
export const ActiveCardioExerciseFragmentFragmentDoc = gql`
    fragment ActiveCardioExerciseFragment on ActiveCardioExercise {
  type
  id
  xid
  name
  notes
  machine_number
  video_url
  seat_height
  intervals {
    end_at
    id
    duration {
      ...ActiveParameterFragment
    }
    distance {
      ...ActiveParameterFragment
    }
    tempo {
      ...ActiveParameterFragment
    }
    intensity {
      ...ActiveParameterFragment
    }
    angle {
      ...ActiveParameterFragment
    }
    resistance {
      ...ActiveParameterFragment
    }
    rest {
      ...ActiveParameterFragment
    }
    target_heart_rate {
      ...ActiveParameterFragment
    }
  }
}
    ${ActiveParameterFragmentFragmentDoc}`;
export const ParameterFragmentFragmentDoc = gql`
    fragment ParameterFragment on Parameter {
  max
  val
  unit
}
    `;
export const StrengthExerciseFragmentFragmentDoc = gql`
    fragment StrengthExerciseFragment on StrengthExercise {
  type
  id
  xid
  name
  notes
  machine_number
  seat_height
  sets {
    id
    reps {
      ...ParameterFragment
    }
    weight {
      ...ParameterFragment
    }
    rest {
      ...ParameterFragment
    }
    dropsets {
      id
      reps {
        ...ParameterFragment
      }
      weight {
        ...ParameterFragment
      }
    }
  }
}
    ${ParameterFragmentFragmentDoc}`;
export const CardioExerciseFragmentFragmentDoc = gql`
    fragment CardioExerciseFragment on CardioExercise {
  type
  id
  xid
  name
  notes
  machine_number
  seat_height
  intervals {
    id
    duration {
      ...ParameterFragment
    }
    distance {
      ...ParameterFragment
    }
    tempo {
      ...ParameterFragment
    }
    intensity {
      ...ParameterFragment
    }
    angle {
      ...ParameterFragment
    }
    resistance {
      ...ParameterFragment
    }
    rest {
      ...ParameterFragment
    }
  }
}
    ${ParameterFragmentFragmentDoc}`;
export const EndActiveWorkoutDocument = gql`
    mutation EndActiveWorkout {
  endActiveWorkout {
    id
  }
}
    `;
export type EndActiveWorkoutMutationFn = Apollo.MutationFunction<EndActiveWorkoutMutation, EndActiveWorkoutMutationVariables>;

/**
 * __useEndActiveWorkoutMutation__
 *
 * To run a mutation, you first call `useEndActiveWorkoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndActiveWorkoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endActiveWorkoutMutation, { data, loading, error }] = useEndActiveWorkoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useEndActiveWorkoutMutation(baseOptions?: Apollo.MutationHookOptions<EndActiveWorkoutMutation, EndActiveWorkoutMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EndActiveWorkoutMutation, EndActiveWorkoutMutationVariables>(EndActiveWorkoutDocument, options);
}
export type EndActiveWorkoutMutationHookResult = ReturnType<typeof useEndActiveWorkoutMutation>;
export type EndActiveWorkoutMutationResult = Apollo.MutationResult<EndActiveWorkoutMutation>;
export type EndActiveWorkoutMutationOptions = Apollo.BaseMutationOptions<EndActiveWorkoutMutation, EndActiveWorkoutMutationVariables>;
export const EndActiveWorkoutDropsetDocument = gql`
    mutation EndActiveWorkoutDropset($input: EndDropsetInput!) {
  endActiveWorkoutDropset(input: $input) {
    id
  }
}
    `;
export type EndActiveWorkoutDropsetMutationFn = Apollo.MutationFunction<EndActiveWorkoutDropsetMutation, EndActiveWorkoutDropsetMutationVariables>;

/**
 * __useEndActiveWorkoutDropsetMutation__
 *
 * To run a mutation, you first call `useEndActiveWorkoutDropsetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndActiveWorkoutDropsetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endActiveWorkoutDropsetMutation, { data, loading, error }] = useEndActiveWorkoutDropsetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndActiveWorkoutDropsetMutation(baseOptions?: Apollo.MutationHookOptions<EndActiveWorkoutDropsetMutation, EndActiveWorkoutDropsetMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EndActiveWorkoutDropsetMutation, EndActiveWorkoutDropsetMutationVariables>(EndActiveWorkoutDropsetDocument, options);
}
export type EndActiveWorkoutDropsetMutationHookResult = ReturnType<typeof useEndActiveWorkoutDropsetMutation>;
export type EndActiveWorkoutDropsetMutationResult = Apollo.MutationResult<EndActiveWorkoutDropsetMutation>;
export type EndActiveWorkoutDropsetMutationOptions = Apollo.BaseMutationOptions<EndActiveWorkoutDropsetMutation, EndActiveWorkoutDropsetMutationVariables>;
export const EndActiveWorkoutIntervalDocument = gql`
    mutation EndActiveWorkoutInterval($input: EndIntervalInput!) {
  endActiveWorkoutInterval(input: $input) {
    id
  }
}
    `;
export type EndActiveWorkoutIntervalMutationFn = Apollo.MutationFunction<EndActiveWorkoutIntervalMutation, EndActiveWorkoutIntervalMutationVariables>;

/**
 * __useEndActiveWorkoutIntervalMutation__
 *
 * To run a mutation, you first call `useEndActiveWorkoutIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndActiveWorkoutIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endActiveWorkoutIntervalMutation, { data, loading, error }] = useEndActiveWorkoutIntervalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndActiveWorkoutIntervalMutation(baseOptions?: Apollo.MutationHookOptions<EndActiveWorkoutIntervalMutation, EndActiveWorkoutIntervalMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EndActiveWorkoutIntervalMutation, EndActiveWorkoutIntervalMutationVariables>(EndActiveWorkoutIntervalDocument, options);
}
export type EndActiveWorkoutIntervalMutationHookResult = ReturnType<typeof useEndActiveWorkoutIntervalMutation>;
export type EndActiveWorkoutIntervalMutationResult = Apollo.MutationResult<EndActiveWorkoutIntervalMutation>;
export type EndActiveWorkoutIntervalMutationOptions = Apollo.BaseMutationOptions<EndActiveWorkoutIntervalMutation, EndActiveWorkoutIntervalMutationVariables>;
export const EndActiveWorkoutSetDocument = gql`
    mutation EndActiveWorkoutSet($input: EndSetInput!) {
  endActiveWorkoutSet(input: $input) {
    id
  }
}
    `;
export type EndActiveWorkoutSetMutationFn = Apollo.MutationFunction<EndActiveWorkoutSetMutation, EndActiveWorkoutSetMutationVariables>;

/**
 * __useEndActiveWorkoutSetMutation__
 *
 * To run a mutation, you first call `useEndActiveWorkoutSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndActiveWorkoutSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endActiveWorkoutSetMutation, { data, loading, error }] = useEndActiveWorkoutSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndActiveWorkoutSetMutation(baseOptions?: Apollo.MutationHookOptions<EndActiveWorkoutSetMutation, EndActiveWorkoutSetMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EndActiveWorkoutSetMutation, EndActiveWorkoutSetMutationVariables>(EndActiveWorkoutSetDocument, options);
}
export type EndActiveWorkoutSetMutationHookResult = ReturnType<typeof useEndActiveWorkoutSetMutation>;
export type EndActiveWorkoutSetMutationResult = Apollo.MutationResult<EndActiveWorkoutSetMutation>;
export type EndActiveWorkoutSetMutationOptions = Apollo.BaseMutationOptions<EndActiveWorkoutSetMutation, EndActiveWorkoutSetMutationVariables>;
export const GetActiveWorkoutDocument = gql`
    query GetActiveWorkout {
  getActiveWorkout {
    id
    tenantId
    clubId
    workoutId
    created_at
    updated_at
    started_at
    name
    memberId
    planId
    end_at
    exercises {
      ... on ActiveStrengthExercise {
        ...ActiveStrengthExerciseFragment
      }
      ... on ActiveCardioExercise {
        ...ActiveCardioExerciseFragment
      }
    }
  }
}
    ${ActiveStrengthExerciseFragmentFragmentDoc}
${ActiveCardioExerciseFragmentFragmentDoc}`;

/**
 * __useGetActiveWorkoutQuery__
 *
 * To run a query within a React component, call `useGetActiveWorkoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveWorkoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveWorkoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveWorkoutQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveWorkoutQuery, GetActiveWorkoutQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetActiveWorkoutQuery, GetActiveWorkoutQueryVariables>(GetActiveWorkoutDocument, options);
}
export function useGetActiveWorkoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveWorkoutQuery, GetActiveWorkoutQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetActiveWorkoutQuery, GetActiveWorkoutQueryVariables>(GetActiveWorkoutDocument, options);
}
export function useGetActiveWorkoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveWorkoutQuery, GetActiveWorkoutQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetActiveWorkoutQuery, GetActiveWorkoutQueryVariables>(GetActiveWorkoutDocument, options);
}
export type GetActiveWorkoutQueryHookResult = ReturnType<typeof useGetActiveWorkoutQuery>;
export type GetActiveWorkoutLazyQueryHookResult = ReturnType<typeof useGetActiveWorkoutLazyQuery>;
export type GetActiveWorkoutSuspenseQueryHookResult = ReturnType<typeof useGetActiveWorkoutSuspenseQuery>;
export type GetActiveWorkoutQueryResult = Apollo.QueryResult<GetActiveWorkoutQuery, GetActiveWorkoutQueryVariables>;
export const StartActiveWorkoutDocument = gql`
    mutation StartActiveWorkout($workoutId: ID!) {
  startActiveWorkout(workoutId: $workoutId) {
    id
    tenantId
    clubId
    workoutId
    created_at
    updated_at
    started_at
    name
    memberId
    planId
    end_at
    exercises {
      ... on ActiveStrengthExercise {
        ...ActiveStrengthExerciseFragment
      }
      ... on ActiveCardioExercise {
        ...ActiveCardioExerciseFragment
      }
    }
  }
}
    ${ActiveStrengthExerciseFragmentFragmentDoc}
${ActiveCardioExerciseFragmentFragmentDoc}`;
export type StartActiveWorkoutMutationFn = Apollo.MutationFunction<StartActiveWorkoutMutation, StartActiveWorkoutMutationVariables>;

/**
 * __useStartActiveWorkoutMutation__
 *
 * To run a mutation, you first call `useStartActiveWorkoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartActiveWorkoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startActiveWorkoutMutation, { data, loading, error }] = useStartActiveWorkoutMutation({
 *   variables: {
 *      workoutId: // value for 'workoutId'
 *   },
 * });
 */
export function useStartActiveWorkoutMutation(baseOptions?: Apollo.MutationHookOptions<StartActiveWorkoutMutation, StartActiveWorkoutMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<StartActiveWorkoutMutation, StartActiveWorkoutMutationVariables>(StartActiveWorkoutDocument, options);
}
export type StartActiveWorkoutMutationHookResult = ReturnType<typeof useStartActiveWorkoutMutation>;
export type StartActiveWorkoutMutationResult = Apollo.MutationResult<StartActiveWorkoutMutation>;
export type StartActiveWorkoutMutationOptions = Apollo.BaseMutationOptions<StartActiveWorkoutMutation, StartActiveWorkoutMutationVariables>;
export const CreateMeasurementDocument = gql`
    mutation CreateMeasurement($input: CreateMeasurementInput!) {
  createMeasurement(input: $input) {
    id
    height
    weight
    fat
    heart_rate
  }
}
    `;
export type CreateMeasurementMutationFn = Apollo.MutationFunction<CreateMeasurementMutation, CreateMeasurementMutationVariables>;

/**
 * __useCreateMeasurementMutation__
 *
 * To run a mutation, you first call `useCreateMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeasurementMutation, { data, loading, error }] = useCreateMeasurementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeasurementMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeasurementMutation, CreateMeasurementMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMeasurementMutation, CreateMeasurementMutationVariables>(CreateMeasurementDocument, options);
}
export type CreateMeasurementMutationHookResult = ReturnType<typeof useCreateMeasurementMutation>;
export type CreateMeasurementMutationResult = Apollo.MutationResult<CreateMeasurementMutation>;
export type CreateMeasurementMutationOptions = Apollo.BaseMutationOptions<CreateMeasurementMutation, CreateMeasurementMutationVariables>;
export const GetCurrentMemberDocument = gql`
    query GetCurrentMember {
  getCurrentMember {
    id
    email
    name
    tenantId
    phone_number
    created_at
    updated_at
    picture
    gender
    address
    birthdate
    measurement {
      height
      weight
      fat
      heart_rate
    }
    profile_workouts {
      items {
        id
        name
        created_at
        updated_at
        trainerId
      }
      nextToken
    }
    plans {
      items {
        id
        tenantId
        weeks
        meetings
        created_at
        updated_at
        trainerId
        memberId
        trainer {
          name
          id
          picture
        }
        events {
          items {
            id
            start_at
          }
          nextToken
        }
        workouts {
          items {
            id
            name
            created_at
            updated_at
          }
          nextToken
        }
      }
      nextToken
    }
  }
}
    `;

/**
 * __useGetCurrentMemberQuery__
 *
 * To run a query within a React component, call `useGetCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentMemberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentMemberQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentMemberQuery, GetCurrentMemberQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCurrentMemberQuery, GetCurrentMemberQueryVariables>(GetCurrentMemberDocument, options);
}
export function useGetCurrentMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentMemberQuery, GetCurrentMemberQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCurrentMemberQuery, GetCurrentMemberQueryVariables>(GetCurrentMemberDocument, options);
}
export function useGetCurrentMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentMemberQuery, GetCurrentMemberQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCurrentMemberQuery, GetCurrentMemberQueryVariables>(GetCurrentMemberDocument, options);
}
export type GetCurrentMemberQueryHookResult = ReturnType<typeof useGetCurrentMemberQuery>;
export type GetCurrentMemberLazyQueryHookResult = ReturnType<typeof useGetCurrentMemberLazyQuery>;
export type GetCurrentMemberSuspenseQueryHookResult = ReturnType<typeof useGetCurrentMemberSuspenseQuery>;
export type GetCurrentMemberQueryResult = Apollo.QueryResult<GetCurrentMemberQuery, GetCurrentMemberQueryVariables>;
export const UpdateMemberProfileDocument = gql`
    mutation UpdateMemberProfile($input: UpdateMemberProfileInput!) {
  updateMemberProfile(input: $input) {
    id
  }
}
    `;
export type UpdateMemberProfileMutationFn = Apollo.MutationFunction<UpdateMemberProfileMutation, UpdateMemberProfileMutationVariables>;

/**
 * __useUpdateMemberProfileMutation__
 *
 * To run a mutation, you first call `useUpdateMemberProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberProfileMutation, { data, loading, error }] = useUpdateMemberProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberProfileMutation, UpdateMemberProfileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateMemberProfileMutation, UpdateMemberProfileMutationVariables>(UpdateMemberProfileDocument, options);
}
export type UpdateMemberProfileMutationHookResult = ReturnType<typeof useUpdateMemberProfileMutation>;
export type UpdateMemberProfileMutationResult = Apollo.MutationResult<UpdateMemberProfileMutation>;
export type UpdateMemberProfileMutationOptions = Apollo.BaseMutationOptions<UpdateMemberProfileMutation, UpdateMemberProfileMutationVariables>;
export const GetWorkoutByIdDocument = gql`
    query GetWorkoutById($workoutId: ID!) {
  getWorkoutById(workoutId: $workoutId) {
    id
    tenantId
    clubId
    created_at
    updated_at
    trainerId
    memberId
    name
    notes
    library
    trainer {
      id
      name
      picture
    }
    exercises {
      __typename
      ... on StrengthExercise {
        ...StrengthExerciseFragment
      }
      ... on CardioExercise {
        ...CardioExerciseFragment
      }
    }
  }
}
    ${StrengthExerciseFragmentFragmentDoc}
${CardioExerciseFragmentFragmentDoc}`;

/**
 * __useGetWorkoutByIdQuery__
 *
 * To run a query within a React component, call `useGetWorkoutByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkoutByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkoutByIdQuery({
 *   variables: {
 *      workoutId: // value for 'workoutId'
 *   },
 * });
 */
export function useGetWorkoutByIdQuery(baseOptions: Apollo.QueryHookOptions<GetWorkoutByIdQuery, GetWorkoutByIdQueryVariables> & ({ variables: GetWorkoutByIdQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWorkoutByIdQuery, GetWorkoutByIdQueryVariables>(GetWorkoutByIdDocument, options);
}
export function useGetWorkoutByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkoutByIdQuery, GetWorkoutByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWorkoutByIdQuery, GetWorkoutByIdQueryVariables>(GetWorkoutByIdDocument, options);
}
export function useGetWorkoutByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkoutByIdQuery, GetWorkoutByIdQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWorkoutByIdQuery, GetWorkoutByIdQueryVariables>(GetWorkoutByIdDocument, options);
}
export type GetWorkoutByIdQueryHookResult = ReturnType<typeof useGetWorkoutByIdQuery>;
export type GetWorkoutByIdLazyQueryHookResult = ReturnType<typeof useGetWorkoutByIdLazyQuery>;
export type GetWorkoutByIdSuspenseQueryHookResult = ReturnType<typeof useGetWorkoutByIdSuspenseQuery>;
export type GetWorkoutByIdQueryResult = Apollo.QueryResult<GetWorkoutByIdQuery, GetWorkoutByIdQueryVariables>;
export const ListActiveWorkoutsHistoryDocument = gql`
    query ListActiveWorkoutsHistory {
  listActiveWorkoutsHistory {
    items {
      id
      end_at
      started_at
      name
    }
    nextToken
  }
}
    `;

/**
 * __useListActiveWorkoutsHistoryQuery__
 *
 * To run a query within a React component, call `useListActiveWorkoutsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveWorkoutsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveWorkoutsHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useListActiveWorkoutsHistoryQuery(baseOptions?: Apollo.QueryHookOptions<ListActiveWorkoutsHistoryQuery, ListActiveWorkoutsHistoryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListActiveWorkoutsHistoryQuery, ListActiveWorkoutsHistoryQueryVariables>(ListActiveWorkoutsHistoryDocument, options);
}
export function useListActiveWorkoutsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActiveWorkoutsHistoryQuery, ListActiveWorkoutsHistoryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListActiveWorkoutsHistoryQuery, ListActiveWorkoutsHistoryQueryVariables>(ListActiveWorkoutsHistoryDocument, options);
}
export function useListActiveWorkoutsHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActiveWorkoutsHistoryQuery, ListActiveWorkoutsHistoryQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListActiveWorkoutsHistoryQuery, ListActiveWorkoutsHistoryQueryVariables>(ListActiveWorkoutsHistoryDocument, options);
}
export type ListActiveWorkoutsHistoryQueryHookResult = ReturnType<typeof useListActiveWorkoutsHistoryQuery>;
export type ListActiveWorkoutsHistoryLazyQueryHookResult = ReturnType<typeof useListActiveWorkoutsHistoryLazyQuery>;
export type ListActiveWorkoutsHistorySuspenseQueryHookResult = ReturnType<typeof useListActiveWorkoutsHistorySuspenseQuery>;
export type ListActiveWorkoutsHistoryQueryResult = Apollo.QueryResult<ListActiveWorkoutsHistoryQuery, ListActiveWorkoutsHistoryQueryVariables>;